import { WMSLayer } from './LayerCategory';
import './UserLayerCategory.css';

interface UserLayerCategoryProps {
  layers: WMSLayer[];
  onLayerToggle: (layerId: string, visible: boolean) => void;
  onLayerDelete: (layerId: string) => void;
}

const UserLayerCategory = ({
  layers,
  onLayerToggle,
  onLayerDelete,
}: UserLayerCategoryProps) => {
  if (layers.length === 0) return null;

  return (
    <div className="user-layer-category">
      {layers.map((layer) => (
        <div key={layer.id} className="user-layer-item">
          <div className="user-layer-controls">
            <input
              type="checkbox"
              id={`user-layer-${layer.id}`}
              className="layer-checkbox"
              checked={layer.visible}
              onChange={(e) => onLayerToggle(layer.id, e.target.checked)}
            />
            <label
              htmlFor={`user-layer-${layer.id}`}
              className="layer-label"
            >
              {layer.name}
            </label>
          </div>
          <button
            className="delete-layer-button"
            onClick={() => onLayerDelete(layer.id)}
            title="Delete layer"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default UserLayerCategory;
